<template>
  <section>
    <TitleBlock
      :subtitle="content.subtitle"
      :title="content.title"
      :description="content.description"
      center
      :buttons="content.buttons" />
    <ul class="flex flex-col justify-center md:flex-row gap-2 md:gap-4 lg:gap-6 px-5 md:px-12.5 lg:px-25">
      <FeedCard
        v-for="(the_news, index) in news"
        :key="`news-index-${index}`"
        :item="the_news"
        class="grow basis-0 md:border-0 [&_p]:text-inherit"
        forceVertical />
    </ul>
    <OptionalButtons
      :buttons="[
        {
          label: $t('news.see_all'),
          link: newsIndexUrl
        }
      ]"
      class="mx-auto" />
  </section>
</template>
<script lang="ts">
  import { OptionalButtons, TitleBlock } from "@/components/blocks";
  import FeedCard from "@/components/cards/FeedCard.vue";
  import { useNewsStore } from "@/stores";

  export default {
    name: "FeaturedNewsSection",
    components: { FeedCard, OptionalButtons, TitleBlock },
    props: {
      content: {
        type: Object,
        required: true
      }
    },
    data() {
      return {
        news: [] as News[]
      };
    },
    computed: {
      newsIndexUrl() {
        return (
          window.location.origin +
          this.$router.resolve({ name: `${this.$routes.NEWS.INDEX}:${this.$i18n.locale}` }).fullPath
        );
      }
    },
    async mounted() {
      const newsStore = useNewsStore();
      this.news = (await newsStore.all()).slice(0, 3);
    }
  };
</script>
